export default __webpack_public_path__ + "static/josh_bw-c55c980eb4ec918d4a5ef7649f5d8b85.jpg";